import { DateTime, Duration } from 'luxon';
import { flip, map, mapObjIndexed, path, pipe, split } from 'ramda';
import {
  BONUS_CONTENT_MACRO_TO_API_MAP,
  BS_API_BONUS_PARTIAL_SCHEMA
} from '../../constants';

const BS_API_DATE_FORMAT = 'dd.MM.yyyy HH:mm:ss';

export const getFieldsForMacros = (bonus) =>
  // prettier-ignore
  map(pipe(
		split('.'),
		flip(path)(bonus)
	))(BONUS_CONTENT_MACRO_TO_API_MAP);

const parseBsBonusDate = (srcDate, timezone) =>
  srcDate != null
    ? DateTime.fromFormat(srcDate, BS_API_DATE_FORMAT, {
        zone: 'UTC'
      }).setZone(timezone)
    : srcDate;
const parseBonusDuration = (srcDuration) =>
  srcDuration != null
    ? Duration.fromObject({ hours: srcDuration })
    : srcDuration;

export const getMacrosData = (bonus, timezone) => {
  const parsedBonusForMacros = mapObjIndexed((value, key) => {
    const type = BS_API_BONUS_PARTIAL_SCHEMA[key];

    switch (type) {
      case 'datetime':
        return parseBsBonusDate(value, timezone);
      case 'duration':
        return parseBonusDuration(value);
      default:
        return value;
    }
  })(bonus);

  return getFieldsForMacros(parsedBonusForMacros);
};
